import * as React from 'react';
import { useState } from 'react';

import { compose } from 'recompose';

import API from 'js/lib/api';
import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';
import Retracked from 'js/lib/retracked';
import { get as getUser } from 'js/lib/user';

import { Notification } from '@coursera/coursera-ui';

import ResetForm from 'bundles/authentication/components/reset-password/ResetForm';
import { LEARNER_HELP_CENTER_LINK } from 'bundles/authentication/constants';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import TrackedDiv from 'bundles/page/components/TrackedDiv';
import { API_BEFORE_SEND, API_ERROR, API_SUCCESS } from 'bundles/phoenix/components/ApiNotification';
import type { ApiStatusType } from 'bundles/phoenix/components/ApiNotification';

import _t from 'i18n!nls/authentication';

const api = API('', { type: 'rest' });

const ResetPage = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatusType>(API_BEFORE_SEND);

  const submitEmail = async (email: string) => {
    setApiStatus(API_BEFORE_SEND);
    try {
      await api.post('api/password/v1/requestReset', {
        data: { email },
      });
      setApiStatus(API_SUCCESS);
    } catch {
      setApiStatus(API_ERROR);
    }
  };

  return (
    <div className="rc-ResetPage">
      <PageHeader hideRightNav hideSearch />
      <main role="main" className="auth-page-container">
        <section className="auth-form-container">
          <h1 className="auth-page-title">{_t('Reset your password')}</h1>
          {apiStatus !== API_BEFORE_SEND ? (
            <TrackedDiv trackingName="reset_request_sent" withVisibilityTracking={true}>
              <Notification
                type="info"
                message={
                  <FormattedHTMLMessage
                    message={_t(
                      `We are sending instructions to reset your password. If you do not receive an email, check your spam folder or make sure this email address is registered with Coursera. For help, go to the {learnerHelpCenterLink}.`
                    )}
                    learnerHelpCenterLink={<a href={LEARNER_HELP_CENTER_LINK}>Learner Help Center</a>}
                  />
                }
              />
            </TrackedDiv>
          ) : (
            <ResetForm onSubmit={submitEmail} userEmail={getUser().email_address} />
          )}
        </section>
      </main>
      <PageFooter />
    </div>
  );
};

export default compose<{}, {}>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      page: 'reset_password_page',
    },
  }))
)(ResetPage);
